import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSwitchModule } from 'ngx-ui-switch';
import { DatePickerModule } from '../shared/directives/date-picker.module';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DollarRateModalComponent } from './dollar-rate-modal/dollar-rate-modal.component';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DollarRateDetailsComponent } from './dollar-rate-details/dollar-rate-details.component';
import { EditDollarRateModalComponent } from './edit-dollar-rate-modal/edit-dollar-rate-modal.component';

@NgModule({
    imports: [
        CommonModule, DatePickerModule, SharedModule, FormsModule, UiSwitchModule, ReactiveFormsModule,
        RouterModule, NgbModule,
        DollarRateModalComponent, DollarRateDetailsComponent, EditDollarRateModalComponent
    ], providers: [],
    exports: [DollarRateModalComponent, EditDollarRateModalComponent]
})
export class DollarRateModule { }
